import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { useAuth } from './AuthContext';

// Tenant owner/admin (raw membership role; `owner` reads as `admin` on `role`)
// or the platform super-admin — the same set the More menu shows admin entries
// to. The backend still enforces (`require_admin` / `require_enterprise_admin`);
// this is a UX gate so non-admins never land on a page of 403s.
export const isTenantAdminUser = (user) =>
  !!user?.is_super_admin || ['owner', 'admin'].includes(user?.membership_role);

// Layout route for pages whose every endpoint is admin-gated (Organization
// Settings, Enterprise, Brand & Website). Hiding the nav entry was not enough:
// by URL a loan officer got a page of 403 toasts and an empty form (ticket 98
// N3/N7). Rendered inside PortalLayout, so auth is already resolved here.
export default function RequireTenantAdmin() {
  const { user } = useAuth();
  if (isTenantAdminUser(user)) return <Outlet />;
  return (
    <div className="p-10 max-w-lg mx-auto text-center" data-testid="admin-only">
      <Shield size={40} className="mx-auto text-slate-300 mb-3" />
      <div className="font-serif text-xl font-bold" style={{ color: '#070B5F' }}>Admins only</div>
      <div className="text-sm text-slate-500 mt-2">
        This page is for workspace owners and admins. Ask your admin if you need something changed here.
      </div>
      <Link to="/portal" className="inline-block mt-4 text-sm font-medium" style={{ color: '#6BA82E' }}>
        Back to dashboard
      </Link>
    </div>
  );
}
